export class HomeData {
  portfolioCount: number[]
  dates: string[]
  managementCount: number[]
}
